import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

function Banner(props) {
  return (
    <div className="service_usa" style={{ backgroundColor: "#281d40" }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banenr_content">
              <h1>
                A Trusted <span>Web3 Development</span> Company
              </h1>
              <p>
                We excel in crafting highly interactive web 3.0 solutions by
                skillfully blending blockchain, AI, and IoT technologies. Our
                Web3 developer's innovative approach has led to a 99% increase
                in client satisfaction and engagement.
              </p>
              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Let’s Connect!
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="mt-auto">
            <StaticImage
              src="../../images/services-usa/web3/banner.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={776}
              height={667}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
